var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "panel-story-group b-shadow-1",
      on: {
        click: function($event) {
          _vm.pass_to_filter()
        }
      }
    },
    [
      _c("figure", [
        _c("img", {
          attrs: { src: _vm.story._mapping_story_overzicht_afbeelding, alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.story.post_title))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib?{}!./scripts/vue/PanelStoryGroup.vue?vue&type=template&id=005635aa&
// module id = 67
// module chunks = 0